import React from 'react';
import { AuthType } from './types';
import { LocalAuthProvider } from './local/LocalAuthProvider';
import { CognitoAuthProvider } from './cognito/CognitoAuthProvider';

interface AuthProviderProperties {
  children: React.ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProperties> = ({ children }) => {
  const authType: AuthType = import.meta.env.VITE_API_AUTH_STRATEGY;

  switch (authType) {
    case 'cognito': {
      return <CognitoAuthProvider>{children}</CognitoAuthProvider>;
    }
    case 'local': {
      return <LocalAuthProvider>{children}</LocalAuthProvider>;
    }
    default: {
      const type: never = authType;
      throw new Error(`Unsupported auth type found in AuthProvider: ${type}`);
    }
  }
};
